import { render, staticRenderFns } from "./AddAuthor.vue?vue&type=template&id=4afdcddf"
import script from "./AddAuthor.vue?vue&type=script&lang=js"
export * from "./AddAuthor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports